/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A custom scalar representing a date in ISO 8601 format. */
  AWSDate: { input: any; output: any; }
  /** A custom scalar representing a date and time in ISO 8601 format. */
  AWSDateTime: { input: any; output: any; }
  /** A custom scalar representing a JSON object as a string. */
  AWSJSON: { input: any; output: any; }
  /** Arbitrary-precision decimal represented as a JSON number (no quotes). */
  BigDecimal: { input: any; output: any; }
};

export type AddCommentToExceptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  exceptionId: Scalars['ID']['input'];
};

export type AdditionalClassification = {
  __typename?: 'AdditionalClassification';
  code?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Represents contact details with email and phone number. */
export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  provinceStateRegionCode?: Maybe<Scalars['String']['output']>;
};

export type AssignExceptionInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exceptionId: Scalars['ID']['input'];
};

export type Classification = {
  __typename?: 'Classification';
  code?: Maybe<Scalars['String']['output']>;
  descriptions?: Maybe<Array<Maybe<TariffDescription>>>;
};

export type CommercialDocument = {
  __typename?: 'CommercialDocument';
  currency?: Maybe<Scalars['String']['output']>;
  declarationAmount?: Maybe<Scalars['BigDecimal']['output']>;
  documentNbr?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CommercialDocumentType>;
  useAsBaseValue?: Maybe<Scalars['Boolean']['output']>;
};

export enum CommercialDocumentType {
  Crpo = 'CRPO',
  Fci = 'FCI',
  Mi = 'MI',
  Tcci = 'TCCI',
  Tcpo = 'TCPO'
}

/** A simplified representation of a consignment. */
export type Consignment = Node & {
  __typename?: 'Consignment';
  actualShipmentCount?: Maybe<Scalars['Int']['output']>;
  /** Audit trail entries for this consignment. */
  auditTrail?: Maybe<ConsignmentAuditTrailPage>;
  billOfLadingNbr?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  containerNbrs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  countryOfImport?: Maybe<Scalars['String']['output']>;
  dischargeCountry?: Maybe<Scalars['String']['output']>;
  /** All documents associated with this consignment. */
  documents?: Maybe<Array<Maybe<ConsignmentDocument>>>;
  /** The vehicle used for transporting this consignment. */
  equipmentVehicle: EquipmentVehicle;
  /** A list of open exceptions associated with this consignment. */
  exceptions?: Maybe<ExceptionPage>;
  expectedShipmentCount?: Maybe<Scalars['Int']['output']>;
  health: HealthIndicator;
  id: Scalars['ID']['output'];
  involvedParties?: Maybe<Array<Maybe<DeclarationParty>>>;
  modeOfTransport?: Maybe<TransportMode>;
  /** A count of open exceptions associated with this consignment. */
  openExceptionCount: Scalars['Int']['output'];
  originCountry?: Maybe<Scalars['String']['output']>;
  productDivisions?: Maybe<Array<Maybe<ProductDivision>>>;
  steps?: Maybe<Array<ProcessStep>>;
  /** The workflow instance associated with this consignment. The relationship is 1:1. */
  workflowInstance?: Maybe<WorkflowInstance>;
};


/** A simplified representation of a consignment. */
export type ConsignmentAuditTrailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortDirection>;
};


/** A simplified representation of a consignment. */
export type ConsignmentExceptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsignmentAuditExceptionEntry = {
  __typename?: 'ConsignmentAuditExceptionEntry';
  exceptionAlias: Scalars['String']['output'];
  exceptionId: Scalars['ID']['output'];
  exceptionStatus: ExceptionStatus;
  id: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
};

export type ConsignmentAuditStepEntry = {
  __typename?: 'ConsignmentAuditStepEntry';
  id: Scalars['ID']['output'];
  stepTitle: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
};

/** An entry in a consignment's audit trail. */
export type ConsignmentAuditTrailEntry = ConsignmentAuditExceptionEntry | ConsignmentAuditStepEntry;

/** A paginated list of AuditTrail entries for consignments */
export type ConsignmentAuditTrailPage = {
  __typename?: 'ConsignmentAuditTrailPage';
  items?: Maybe<Array<ConsignmentAuditTrailEntry>>;
  pageInfo: PageInfo;
};

/** Union type for all document types. */
export type ConsignmentDocument = CustomsEntryDocument | CustomsStatusDocument | FilingPackDocument;

/** A paginated list of Consignments. */
export type ConsignmentPage = {
  __typename?: 'ConsignmentPage';
  items?: Maybe<Array<Consignment>>;
  pageInfo: PageInfo;
};

/** Container for all Consignment-related queries. */
export type ConsignmentQuery = {
  __typename?: 'ConsignmentQuery';
  /** Gets a single consignment by its unique ID. */
  get?: Maybe<Consignment>;
};


/** Container for all Consignment-related queries. */
export type ConsignmentQueryGetArgs = {
  id: Scalars['ID']['input'];
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Represents a Customs Entry document associated with a consignment. */
export type CustomsEntryDocument = DocumentInterface & {
  __typename?: 'CustomsEntryDocument';
  brokerReferenceNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  customsReferenceNumber?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  filingPackId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stepTitle: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  type: DocumentType;
};

/** Represents a Customs Status document associated with a consignment. */
export type CustomsStatusDocument = DocumentInterface & {
  __typename?: 'CustomsStatusDocument';
  brokerReferenceNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  customsReferenceNumber?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  filingPackId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stepTitle: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  type: DocumentType;
};

/** A container for all dashboard-related metrics and data. */
export type Dashboard = {
  __typename?: 'Dashboard';
  /** The number of critical tasks (e.g., ETA 0-2 days) for the current user. */
  criticalTasksCount: Scalars['Int']['output'];
  /** The total number of open exceptions assigned to the current user. */
  myOpenExceptionsCount: Scalars['Int']['output'];
  /** A list of recent notifications for the current user. */
  notifications?: Maybe<NotificationPage>;
  /** The number of tasks due today for the current user. */
  tasksDueTodayCount: Scalars['Int']['output'];
};


/** A container for all dashboard-related metrics and data. */
export type DashboardNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represent a declaration party */
export type DeclarationParty = {
  __typename?: 'DeclarationParty';
  address?: Maybe<Address>;
  contactDetails?: Maybe<ContactDetails>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DeclarationPartyType>;
};

/** Declaration parties */
export enum DeclarationPartyType {
  Broker = 'BROKER',
  Carrier = 'CARRIER',
  Forwarder = 'FORWARDER',
  Importer = 'IMPORTER'
}

/** Base interface for all documents associated with a consignment. */
export type DocumentInterface = {
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stepTitle: Scalars['String']['output'];
  type: DocumentType;
};

export enum DocumentType {
  CustomsEntry = 'CUSTOMS_ENTRY',
  CustomsStatus = 'CUSTOMS_STATUS',
  FilingPack = 'FILING_PACK'
}

/** Represents a transport vehicle (e.g., a ship or plane). */
export type EquipmentVehicle = {
  __typename?: 'EquipmentVehicle';
  actualShipmentCount: Scalars['Int']['output'];
  carrier?: Maybe<Scalars['String']['output']>;
  /** The total number of consignments on this vehicle. */
  consignmentCount: Scalars['Int']['output'];
  /** A list of consignments associated with this vehicle. */
  consignments?: Maybe<ConsignmentPage>;
  dischargeCountry?: Maybe<Scalars['String']['output']>;
  expectedShipmentCount: Scalars['Int']['output'];
  health: HealthIndicator;
  id: Scalars['ID']['output'];
  modeOfTransport: TransportMode;
  /** A count of open exceptions associated with the consignments of this vehicle. */
  openExceptionCount: Scalars['Int']['output'];
  originCountry?: Maybe<Scalars['String']['output']>;
  plannedDischargeDate: Scalars['AWSDate']['output'];
  voyageNumber?: Maybe<Scalars['String']['output']>;
};


/** Represents a transport vehicle (e.g., a ship or plane). */
export type EquipmentVehicleConsignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for filtering the `equipmentVehicle.list` query. */
export type EquipmentVehicleFilterInput = {
  dischargeCountry?: InputMaybe<Scalars['String']['input']>;
  modeOfTransport?: InputMaybe<TransportMode>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  plannedDischargeDateFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  plannedDischargeDateTo?: InputMaybe<Scalars['AWSDate']['input']>;
  /** A search term to filter exceptions by general text fields. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

/** Input for ordering the `equipmentVehicle.list` query. */
export type EquipmentVehicleOrderByInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<EquipmentVehicleSortField>;
};

/** A paginated list of EquipmentVehicles. */
export type EquipmentVehiclePage = {
  __typename?: 'EquipmentVehiclePage';
  items?: Maybe<Array<EquipmentVehicle>>;
  pageInfo: PageInfo;
};

/** Container for all Equipment Vehicle-related queries. */
export type EquipmentVehicleQuery = {
  __typename?: 'EquipmentVehicleQuery';
  /** Gets a single vehicle by its unique ID. */
  get?: Maybe<EquipmentVehicle>;
  /** Lists all vehicles with specific filtering and sorting. */
  list?: Maybe<EquipmentVehiclePage>;
  /** Lists all possible countries. FieldType can be 'origin', 'discharge', or 'import'. */
  listCountries: Array<Scalars['String']['output']>;
};


/** Container for all Equipment Vehicle-related queries. */
export type EquipmentVehicleQueryGetArgs = {
  id: Scalars['ID']['input'];
};


/** Container for all Equipment Vehicle-related queries. */
export type EquipmentVehicleQueryListArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
  filter?: InputMaybe<EquipmentVehicleFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EquipmentVehicleOrderByInput>;
};


/** Container for all Equipment Vehicle-related queries. */
export type EquipmentVehicleQueryListCountriesArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
  fieldType: Scalars['String']['input'];
};

/** Fields available for sorting equipment vehicles. */
export enum EquipmentVehicleSortField {
  PlannedDischargeDate = 'PLANNED_DISCHARGE_DATE'
}

/** Represents a data or compliance issue that needs attention. */
export type Exception = Node & {
  __typename?: 'Exception';
  alias: Scalars['String']['output'];
  assignee?: Maybe<User>;
  /** A chronological log of all activity on this exception. */
  auditTrail: ExceptionAuditTrailPage;
  /** The primary consignment this exception is associated with. */
  consignment: Consignment;
  creationDate: Scalars['AWSDateTime']['output'];
  customsTerritory: Scalars['String']['output'];
  /** A user-friendly description for the exception, derived from its primary message. */
  description: Scalars['String']['output'];
  guidance?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages?: Maybe<Array<Maybe<Message>>>;
  resolutionType: ExceptionResolutionType;
  retryable: Scalars['Boolean']['output'];
  status: ExceptionStatus;
  stepTitle: Scalars['String']['output'];
  targetResolutionDate: Scalars['AWSDate']['output'];
};


/** Represents a data or compliance issue that needs attention. */
export type ExceptionAuditTrailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An entry in an exception's audit trail */
export type ExceptionAuditTrailEntry = {
  __typename?: 'ExceptionAuditTrailEntry';
  content?: Maybe<Scalars['String']['output']>;
  fromStatus?: Maybe<ExceptionStatus>;
  id: Scalars['ID']['output'];
  targetUser?: Maybe<User>;
  timestamp: Scalars['AWSDateTime']['output'];
  toStatus?: Maybe<ExceptionStatus>;
  user?: Maybe<User>;
};

/** A paginated list of AuditTrail entries for exceptions */
export type ExceptionAuditTrailPage = {
  __typename?: 'ExceptionAuditTrailPage';
  items?: Maybe<Array<ExceptionAuditTrailEntry>>;
  pageInfo: PageInfo;
};

/** Input for filtering the `exception.list` query. */
export type ExceptionFilterInput = {
  assigneeUserId?: InputMaybe<Scalars['String']['input']>;
  countryOfImport?: InputMaybe<Scalars['String']['input']>;
  exceptionType?: InputMaybe<Scalars['String']['input']>;
  modeOfTransport?: InputMaybe<TransportMode>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  productDivision?: InputMaybe<ProductDivision>;
  /** A search term to filter exceptions by general text fields. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ExceptionStatus>;
  targetResolutionDateFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  targetResolutionDateTo?: InputMaybe<Scalars['AWSDate']['input']>;
};

/** Input for ordering the `exception.list` query. */
export type ExceptionOrderByInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ExceptionSortField>;
};

/** A paginated list of Exceptions. */
export type ExceptionPage = {
  __typename?: 'ExceptionPage';
  items?: Maybe<Array<Exception>>;
  pageInfo: PageInfo;
};

/** Container for all Exception-related queries. */
export type ExceptionQuery = {
  __typename?: 'ExceptionQuery';
  /** Gets a single exception by its unique ID. */
  get?: Maybe<Exception>;
  /** Lists all exceptions with specific filtering and sorting. */
  list?: Maybe<ExceptionPage>;
  /** Lists all possible countries. FieldType can be 'origin', 'discharge', or 'import'. */
  listCountries: Array<Scalars['String']['output']>;
  /** List all possible exception types. */
  types: Array<ExceptionType>;
};


/** Container for all Exception-related queries. */
export type ExceptionQueryGetArgs = {
  id: Scalars['ID']['input'];
};


/** Container for all Exception-related queries. */
export type ExceptionQueryListArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
  filter?: InputMaybe<ExceptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExceptionOrderByInput>;
};


/** Container for all Exception-related queries. */
export type ExceptionQueryListCountriesArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
  fieldType: Scalars['String']['input'];
};


/** Container for all Exception-related queries. */
export type ExceptionQueryTypesArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
};

/** The method by which an exception can be resolved. */
export enum ExceptionResolutionType {
  /** Can be resolved automatically by the system (e.g., via a retry). */
  Auto = 'AUTO',
  /** Requires a fix in an external system. */
  External = 'EXTERNAL',
  /** Can be resolved directly in the CCH UI. */
  Inline = 'INLINE'
}

/** Fields available for sorting exceptions. */
export enum ExceptionSortField {
  CreationDate = 'CREATION_DATE',
  TargetResolutionDate = 'TARGET_RESOLUTION_DATE'
}

/** The current status of an Exception. */
export enum ExceptionStatus {
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  Retrying = 'RETRYING'
}

export type ExceptionStatusUpdatePayload = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exceptionId: Scalars['ID']['input'];
};

/** Describes a exception type, which can be used to categorize exceptions. */
export type ExceptionType = {
  __typename?: 'ExceptionType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  guidance?: Maybe<Scalars['String']['output']>;
  resolutionType: ExceptionResolutionType;
};

/** Represents a FilingPack document associated with a consignment. */
export type FilingPackDocument = DocumentInterface & {
  __typename?: 'FilingPackDocument';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latestMessage?: Maybe<Scalars['String']['output']>;
  latestStatus?: Maybe<Scalars['String']['output']>;
  latestTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  stepTitle: Scalars['String']['output'];
  type: DocumentType;
};

export enum Health {
  Error = 'ERROR',
  Healthy = 'HEALTHY',
  Warning = 'WARNING'
}

export type HealthIndicator = {
  __typename?: 'HealthIndicator';
  description?: Maybe<Scalars['String']['output']>;
  health: Health;
};

export type InvolvedParty = {
  __typename?: 'InvolvedParty';
  name: Scalars['String']['output'];
};

/**
 * Represents a detailed message associated with a Workflow Instance.
 * Modeled from the CchMessage definition in orchestrator-command.schema.json.
 */
export type Message = {
  __typename?: 'Message';
  code: Scalars['String']['output'];
  /** A flexible object containing key-value pairs of relevant business context. */
  context?: Maybe<Scalars['AWSJSON']['output']>;
  contextResolutionGroupingKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
};

export type MutatedException = {
  __typename?: 'MutatedException';
  assignee?: Maybe<User>;
  id: Scalars['ID']['output'];
  status: ExceptionStatus;
};

/** The root Mutation type, containing all write operations. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Adds a comment to an exception's audit trail. */
  addCommentToException?: Maybe<MutationExceptionPayload>;
  /** Assigns or unassigns an exception to a user. */
  assignException?: Maybe<MutationExceptionPayload>;
  /** Change the default customs territories for the current user. */
  changeUserSelectedTerritories?: Maybe<UserSettings>;
  /** Change the UI settings for the current user. */
  changeUserSettings?: Maybe<UserSettings>;
  /** Retry an exception, optionally with a final comment. */
  retryException?: Maybe<MutationExceptionPayload>;
  /** Submits a customs declaration, advancing the workflow. */
  submitDeclaration?: Maybe<SubmitDeclarationPayload>;
  /** Mark an exception as in progress, optionally with a comment. */
  updateExceptionStatusToInProgress?: Maybe<MutationExceptionPayload>;
  /** Mark an exception as open, optionally with a comment. */
  updateExceptionStatusToOpen?: Maybe<MutationExceptionPayload>;
};


/** The root Mutation type, containing all write operations. */
export type MutationAddCommentToExceptionArgs = {
  input: AddCommentToExceptionInput;
};


/** The root Mutation type, containing all write operations. */
export type MutationAssignExceptionArgs = {
  input: AssignExceptionInput;
};


/** The root Mutation type, containing all write operations. */
export type MutationChangeUserSelectedTerritoriesArgs = {
  selectedTerritories: Array<Scalars['String']['input']>;
};


/** The root Mutation type, containing all write operations. */
export type MutationChangeUserSettingsArgs = {
  uiSettings: Scalars['AWSJSON']['input'];
};


/** The root Mutation type, containing all write operations. */
export type MutationRetryExceptionArgs = {
  input: RetryExceptionInput;
};


/** The root Mutation type, containing all write operations. */
export type MutationSubmitDeclarationArgs = {
  input: SubmitDeclarationInput;
};


/** The root Mutation type, containing all write operations. */
export type MutationUpdateExceptionStatusToInProgressArgs = {
  input: ExceptionStatusUpdatePayload;
};


/** The root Mutation type, containing all write operations. */
export type MutationUpdateExceptionStatusToOpenArgs = {
  input: ExceptionStatusUpdatePayload;
};

export type MutationExceptionPayload = {
  __typename?: 'MutationExceptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  exception?: Maybe<MutatedException>;
};

/** The `Node` interface for global object refetching. */
export type Node = {
  id: Scalars['ID']['output'];
};

/** Represents a notification or alert for a user. */
export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  /** The entity this notification is about, allowing for deep linking. */
  link?: Maybe<NotificationLink>;
  text: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
};

/** An item that a notification can link to. */
export type NotificationLink = Consignment | Exception;

/** A paginated list of Notifications. */
export type NotificationPage = {
  __typename?: 'NotificationPage';
  items?: Maybe<Array<Notification>>;
  pageInfo: PageInfo;
};

/** General pagination info for search results. */
export type PageInfo = {
  __typename?: 'PageInfo';
  message?: Maybe<Scalars['String']['output']>;
  status: SearchResultStatus;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A simplified step in the execution history. */
export type ProcessStep = {
  __typename?: 'ProcessStep';
  /** The timestamp when this step was completed. */
  completedTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  context?: Maybe<ProcessStepContext>;
  /** The timestamp when this step was started, completed or failed. */
  startTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  status: ProcessStepStatus;
  title: Scalars['String']['output'];
};

/** A context for a particular processStep */
export type ProcessStepContext = {
  __typename?: 'ProcessStepContext';
  badge?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['AWSJSON']['output']>;
};

/** The status of a step within a workflow instance. */
export enum ProcessStepStatus {
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export type ProductComponent = {
  __typename?: 'ProductComponent';
  additionalClassifications?: Maybe<Array<Maybe<AdditionalClassification>>>;
  classification?: Maybe<Classification>;
  currency?: Maybe<Scalars['String']['output']>;
  grossWeight?: Maybe<Scalars['Int']['output']>;
  netNetWeight?: Maybe<Scalars['Int']['output']>;
  netWeight?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['BigDecimal']['output']>;
  primaryFlag?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Array<Maybe<ReportingQuantity>>>;
};

/** Different ProductDivisions. */
export enum ProductDivision {
  Apparel = 'APPAREL',
  Equipment = 'EQUIPMENT',
  Footwear = 'FOOTWEAR'
}

/** The root entry point for all data-fetching operations. */
export type Query = {
  __typename?: 'Query';
  /** Entry point for all queries related to Consignments. */
  consignment: ConsignmentQuery;
  /** Provides all data needed for the main dashboard view. */
  dashboard: Dashboard;
  /** Entry point for all queries related to Equipment Vehicles. */
  equipmentVehicle: EquipmentVehicleQuery;
  /** Entry point for all queries related to Exceptions. */
  exception: ExceptionQuery;
  /** Global, multi-entity search. */
  search: SearchResults;
  /** Entry point for all queries related to Shipments. */
  shipment: ShipmentQuery;
  /** Fetches user information */
  user: UserQuery;
};


/** The root entry point for all data-fetching operations. */
export type QueryDashboardArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
};


/** The root entry point for all data-fetching operations. */
export type QuerySearchArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
  filter: SearchFilterInput;
  orderBy?: InputMaybe<SearchOrderByInput>;
};

export type ReportingQuantity = {
  __typename?: 'ReportingQuantity';
  quantity?: Maybe<Scalars['Float']['output']>;
  reportingUnitOfMeasure?: Maybe<Scalars['String']['output']>;
};

export type RetryExceptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exceptionId: Scalars['ID']['input'];
  retryComment?: InputMaybe<Scalars['String']['input']>;
};

/** Input for filtering the global `search` query. */
export type SearchFilterInput = {
  searchTerm: Scalars['String']['input'];
};

/** Input for ordering the global `search` query. */
export type SearchOrderByInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<SearchSortField>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  consignments: ConsignmentPage;
  equipmentVehicles: EquipmentVehiclePage;
  exceptions: ExceptionPage;
};


export type SearchResultsConsignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultsEquipmentVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultsExceptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Status of a search result page. */
export enum SearchResultStatus {
  Success = 'SUCCESS'
}

/** Fields available for sorting global search results. */
export enum SearchSortField {
  CreationDate = 'CREATION_DATE',
  Relevance = 'RELEVANCE'
}

export type Shipment = {
  __typename?: 'Shipment';
  shipmentNbr: Scalars['String']['output'];
  shipmentProductCount: Scalars['Int']['output'];
};

/** A paginated list of Shipments. */
export type ShipmentPage = {
  __typename?: 'ShipmentPage';
  items?: Maybe<Array<Shipment>>;
  pageInfo: PageInfo;
};

export type ShipmentProduct = {
  __typename?: 'ShipmentProduct';
  commercialDocuments?: Maybe<Array<Maybe<CommercialDocument>>>;
  components?: Maybe<Array<Maybe<ProductComponent>>>;
  crPoItemVariantNbr: Scalars['String']['output'];
  crpoNbr?: Maybe<Scalars['String']['output']>;
  division: Scalars['String']['output'];
  isSample?: Maybe<Scalars['Boolean']['output']>;
  manufacturerCountry?: Maybe<Scalars['String']['output']>;
  netWeightInGrams?: Maybe<Scalars['Int']['output']>;
  productCode: Scalars['String']['output'];
  quality?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  size: Scalars['String']['output'];
  stpDetails?: Maybe<Array<Maybe<StpDetails>>>;
};

/** A paginated list of ShipmentProducts. */
export type ShipmentProductPage = {
  __typename?: 'ShipmentProductPage';
  items?: Maybe<Array<ShipmentProduct>>;
  pageInfo: PageInfo;
};

/** Container for all Shipment-related queries. */
export type ShipmentQuery = {
  __typename?: 'ShipmentQuery';
  list?: Maybe<ShipmentPage>;
  listProducts?: Maybe<ShipmentProductPage>;
};


/** Container for all Shipment-related queries. */
export type ShipmentQueryListArgs = {
  consignmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Container for all Shipment-related queries. */
export type ShipmentQueryListProductsArgs = {
  consignmentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shipmentNbr: Scalars['String']['input'];
};

/** Sort direction. */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StpDetails = {
  __typename?: 'StpDetails';
  authorityReportingCode?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  effectiveTo?: Maybe<Scalars['AWSDateTime']['output']>;
  finalDecision?: Maybe<Scalars['String']['output']>;
  finalDecisionDate?: Maybe<Scalars['AWSDateTime']['output']>;
  stpCode?: Maybe<Scalars['String']['output']>;
};

export type SubmitDeclarationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  consignmentId: Scalars['ID']['input'];
};

export type SubmitDeclarationPayload = {
  __typename?: 'SubmitDeclarationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  workflowInstance?: Maybe<WorkflowInstance>;
};

/** The root Subscription type for real-time updates. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggers when an exception assigned to the current user is updated. */
  onMyExceptionUpdate?: Maybe<MutationExceptionPayload>;
};

export type TariffDescription = {
  __typename?: 'TariffDescription';
  languageCode?: Maybe<Scalars['String']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

/** The mode of transport for a vehicle. */
export enum TransportMode {
  Af = 'AF',
  Br = 'BR',
  Rl = 'RL',
  Se = 'SE',
  Tr = 'TR',
  Vl = 'VL'
}

/** Represents a user of the CCH system. */
export type User = Node & {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** A list of open exceptions assigned to this user. */
  openExceptions?: Maybe<ExceptionPage>;
  /** User-specific settings, like selected customs territories. */
  settings?: Maybe<UserSettings>;
};


/** Represents a user of the CCH system. */
export type UserOpenExceptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of Users. */
export type UserPage = {
  __typename?: 'UserPage';
  items?: Maybe<Array<User>>;
  pageInfo: UserPageInfo;
};

/** General pagination info for search results. */
export type UserPageInfo = {
  __typename?: 'UserPageInfo';
  hasMoreResults?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: SearchResultStatus;
};

/** Container for all User-related queries. */
export type UserQuery = {
  __typename?: 'UserQuery';
  /** Lists all users with specific filtering and sorting. You can search for user within multiple customs territories. */
  list?: Maybe<UserPage>;
  /** Gets the currently authenticated user. */
  me: User;
};


/** Container for all User-related queries. */
export type UserQueryListArgs = {
  customsTerritories: Array<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** User-specific preferences and settings. */
export type UserSettings = {
  __typename?: 'UserSettings';
  /** The list of the customs territory codes the user has access to. */
  availableTerritories?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of customs territory codes the user has selected to focus on. */
  selectedTerritories?: Maybe<Array<Scalars['String']['output']>>;
  /** The user's custom settings specific for the UI. */
  uiSettings?: Maybe<Scalars['AWSJSON']['output']>;
};

/** Represents an active or completed instance of a workflow. */
export type WorkflowInstance = {
  __typename?: 'WorkflowInstance';
  workflowDefinitionName?: Maybe<Scalars['String']['output']>;
  workflowDefinitionURI?: Maybe<Scalars['String']['output']>;
  workflowInstanceId?: Maybe<Scalars['String']['output']>;
};

export type DashboardQueryQueryVariables = Exact<{
  customsTerritories: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DashboardQueryQuery = { __typename?: 'Query', dashboard: { __typename?: 'Dashboard', criticalTasksCount: number, myOpenExceptionsCount: number, tasksDueTodayCount: number } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const DashboardQueryDocument = new TypedDocumentString(`
    query DashboardQuery($customsTerritories: [String!]!) {
  dashboard(customsTerritories: $customsTerritories) {
    criticalTasksCount
    myOpenExceptionsCount
    tasksDueTodayCount
  }
}
    `) as unknown as TypedDocumentString<DashboardQueryQuery, DashboardQueryQueryVariables>;